import { cn } from "./cn.js";

/** A small state indicator dot. `pulse` adds a radiating ring — reserved for
 *  genuinely live state (timer running, overlay on air) so it stays meaningful. */
type Tone = "live" | "success" | "warning" | "idle";

type Props = {
  tone?: Tone;
  pulse?: boolean;
  className?: string;
};

const toneClasses: Record<Tone, string> = {
  live: "bg-danger",
  success: "bg-success",
  warning: "bg-warning",
  idle: "bg-ink-faint",
};

export function StatusDot({ tone = "idle", pulse = false, className }: Props) {
  return (
    <span className={cn("relative inline-flex h-2 w-2 shrink-0", className)}>
      {pulse && tone !== "idle" && (
        <span
          className={cn(
            "absolute inline-flex h-full w-full rounded-full opacity-60 animate-ping",
            toneClasses[tone],
          )}
        />
      )}
      <span className={cn("relative inline-flex h-2 w-2 rounded-full", toneClasses[tone])} />
    </span>
  );
}
